const showreels = [
    {
        video: 'https://www.youtube.com/embed/WWp_vwhFmmM?si=Xi1reC7sFd1cVoSj',
        alt: 'composition demo reel'
    },
    {
        video: 'https://www.youtube.com/embed/_67Ivo_NUfI?si=X8opI38nZ4ZTSadu',
        alt: 'sound design demo reel'
    },
    {
        video: 'https://www.youtube.com/embed/Sm0fCOAuBU8?si=NAuWFj-cvHbP44Uy',
        alt: 'game jam demo reel'
    },
    {
        video: 'https://www.youtube.com/embed/T-eNkVyxcfM?si=fpCZspvy45cjwRNF',
        alt: 'voice acting demo reel'
    }
];

export default showreels;
